module.exports = __webpack_public_path__ + "static/img/defalute.133eaac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/defalute.jpg
// module id = eKF2
// module chunks = 127